import styled from 'styled-components'
import { Box, Stack } from '@machobear/design-system'
import { breakpoints, structure, colors } from '@/styles'
import { toUnit } from '@/utils/styles'
import BaseLayout from './base-layout'
import HeaderLayout from './header-layout'

const Section = styled.section`
  padding: 40px 100px 40px;
  height: calc(100vh - ${toUnit(structure.header.height)});
  overflow-y: auto;
  background: ${colors.white};
  width: 100%;

  @media screen and (max-width: ${breakpoints.desktop}) {
    padding: 40px;
  }
`

const SettingsLayout = ({ children, title, description = '' }) => {
  return (
    <BaseLayout title={title}>
      <Section>
        <Stack space="xxsmall">
          <HeaderLayout title={title} description={description} />
          <Box maxWidth="medium">{children}</Box>
        </Stack>
      </Section>
    </BaseLayout>
  )
}

export default SettingsLayout
